import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentBandeau from "../../components/layout/ComponentBandeau";
import BlocToggle from "../../components/layout/ComponentToggle";

import BlocVieDeNosMissions from "../../components/public/colidee/BlocVieDeNosMissions";
import BlocSousMissions from "../../components/public/orgunit/BlocSousMissions";
import BlocEngagements from "../../components/public/engagement/BlocEngagements";
import ComponentSousTitle from "../../components/layout/ComponentSousTitle";
import BlocFiltreOperation from "../../components/public/operation/BlocFiltreOperation";
import { selectInOperationFilters } from "../../redux/ReduxFilter";

import { chgOperationToggle, selectInOperationToggle } from "../../redux/ReduxToggle";

import { Container } from "react-bootstrap";

const PageInoperation = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const _selectInOperationFilters = useSelector(selectInOperationFilters);
  const [viewToggle, setViewToggle] = useState(useSelector(selectInOperationToggle));
  const [anteriorite, setAnteriorite] = useState(31);
  const dispatch = useDispatch();

  const switchView = () => {
    dispatch(chgOperationToggle(!viewToggle));
    setViewToggle(!viewToggle);
  };

  return (
    <>
      <ComponentMenu menuActif="inoperation" />
      <div className="containerHeaderBandeau">
        <ComponentBandeau menu="inOperation" />
        <BlocToggle
          viewToggle={viewToggle}
          switchView={switchView}
          setAnteriorite={setAnteriorite}
          anteriorite={anteriorite}
          curseurInitial={1}
          max={5}
          min={0}
          disabled={true}
          sousMenus={ReduxInstance.sousMenus.filter((item) => item.parent === "inOperation")}
        />
      </div>

      <BlocFiltreOperation
        orgunitPrincipalInOperation={ReduxInstance.orgunitPrincipalInOperation}
        espacePrincipalColidee={ReduxInstance.espacePrincipalColidee}
      />

      {(_selectInOperationFilters.viemissions || _selectInOperationFilters.all) &&
        ReduxInstance.espacePrincipalColidee !== 0 && <BlocVieDeNosMissions />}

      {/* {(_selectInOperationFilters.engagements || _selectInOperationFilters.all) && (
        <BlocEngagements />
      )} */}

      {ReduxInstance.orgunitPrincipalInOperation &&
        ReduxInstance.orgunitPrincipalInOperation !== null &&
        (_selectInOperationFilters.rdvmissions || _selectInOperationFilters.all) && (
          <Container fluid>
            <ComponentSousTitle nom={t("public.filtres.filtre9")} />
            <BlocSousMissions orgunitParent={ReduxInstance.orgunitPrincipalInOperation} />
          </Container>
        )}
    </>
  );
};

export default PageInoperation;
